/**
 * @description 执业经历/社会职务
 */
export enum ExperienceTypeEnum {
  PRACTICE_EXPERIENCE = 1, // 执业经历
  SOCIAL_POSITION = 2 // 社会职务
}
